import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { BillingUiModule } from '@vendasta/billing-ui';
import { TranslateModule } from '@ngx-translate/core';

export interface RetailSummary {
  subtotal: number;
  taxAmount: number;
  firstPayment: number;
  currencyCode: string;
}

@Component({
  selector: 'inventory-ui-retail-summary',
  standalone: true,
  imports: [CommonModule, MatDividerModule, BillingUiModule, TranslateModule],
  templateUrl: './retail-summary.component.html',
  styleUrls: ['./retail-summary.component.scss'],
})
export class RetailSummaryComponent {
  summary = input.required<RetailSummary>();
}
